import { render, staticRenderFns } from "./region_add.vue?vue&type=template&id=5ea83595&scoped=true&"
import script from "./region_add.vue?vue&type=script&lang=js&"
export * from "./region_add.vue?vue&type=script&lang=js&"
import style0 from "./region_add.vue?vue&type=style&index=0&id=5ea83595&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea83595",
  null
  
)

export default component.exports